import React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { IPortalHomePresenter } from "../../presenter/PortalHomePresenter";
import { Affix, Button, Card, Col, Row, Space, Typography } from "antd";
import HeroSearchBar from "../../../search/ui/components/HeroSearchBar";
import Link from "../../../core/ui/components/Link";
import { SearchOutlined, YoutubeOutlined } from "@ant-design/icons";
import Tooltip from "antd/es/tooltip";
const { Title } = Typography;

export interface Props extends PageProps {}
export interface State extends IPortalHomePresenter {}

export default class PortalHomePage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { onSearch } = this.state;
    const { translate } = this.props;
    return (
      <Page {...this.props} className="portal-home">
        <div
          style={{
            position: "fixed",
            zIndex: 999,
            bottom: "7%",
            right: 50
          }}
        ></div>
        <Row className="mx-0">
          <Col
            xs={24}
            sm={24}
            className="text-align-center display-none display-sm-block"
          >
            <Title level={1} className="portal-home-title">
              <i className="fas fa-gavel"></i>
              {translate("app.home_portal")}
            </Title>
          </Col>
          <Col
            xs={24}
            sm={{ span: 20, offset: 2 }}
            lg={{ span: 12, offset: 6 }}
          >
            <HeroSearchBar
              navigator={this.props.router}
              placeholder={translate("search.bar.placeholder")}
              searchActionLabel={translate("search.bar.search_action")}
              advancedSearchHref="/advanced-search"
              advancedSearchLabel={translate(
                "search.bar.advanced_search_action"
              )}
              advancedSearchEnabled={true}
              onSearch={onSearch}
            />
          </Col>
          <Col xs={24} sm={24} style={{ textAlign: "center", paddingTop: 50 }}>
            <Space
              size={"large"}
              className="portal-home-cards-container flex-direction-column flex-direction-md-row"
            >
              <Card className="portal-home-card">
                <Link
                  router={this.props.router}
                  path="/search?collection=STAV&q="
                >
                  {translate("menu.case_law_document")}
                </Link>
              </Card>
            </Space>
          </Col>
        </Row>
      </Page>
    );
  }
}
